export default __webpack_public_path__ + "dd2b1228782d0d72534ca30a8ff94ae2.svg";